export default "__VITE_ASSET__1385d198__"